module.exports = __webpack_public_path__ + "img/sand-rock-big-02.95bf1cdd.png";